export default "<p>rentals works!</p>\n"